export default __webpack_public_path__ + "static/media/kid-10.4920ed2a.jpg";